import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { withProps } from 'recompose'
import withSelectedLocation from 'components/common/hoc/withSelectedLocation'
import { getIsActiveVehicleTrailer } from 'selectors/getActiveVehicle'
import { showStoreLocatorModal } from 'actions/storeLocator'
import { TIRE_QUANTITY_FORM_NAME, TIRE_FRONT_INPUT_NAME, TIRE_REAR_INPUT_NAME } from 'constant'
import { checkIsCompatible } from 'helpers/compatibility'
import { formSelector } from './selectors'
import { getPrice } from './helpers'
import viewModel from './viewModel'
import TireCost from './TireCostForm'
import { getElectricVehicleSpecifications } from 'components/common/ProductFlag/helpers'
import { INVENTORY_STATUS_LOADED } from 'components/common/UpdatingBlock/constants.js'
import { getUserData } from 'components/Appointment/selectors'

// TODO isComaptible spelling mistake comes from BE. It's better to change it in the future.
const mapStateToProps = (state, { compatibilityStatus: { compatibilityType } = {}}) => {
  const { isPilotStore } = getUserData(state)

  return {
    frontTireQuantity: formSelector(state, TIRE_FRONT_INPUT_NAME),
    rearTireQuantity: formSelector(state, TIRE_REAR_INPUT_NAME),
    isCompatible: getIsActiveVehicleTrailer(state) || checkIsCompatible(compatibilityType),
    storeNumber: state.myStore?.storeNumber,
    inventoryStatuses: state.updatingBlocks[INVENTORY_STATUS_LOADED],
    isPilotStore
  }
}

const withFormModel = withProps(() => ({
  model: viewModel
}))

const withCompatibilityStatus = withProps(({
  frontTire: {
    compatibilityStatus: frontCompatibility
  },
  rearTire: {
    compatibilityStatus: rearCompatibility
  }
}) => ({
  compatibilityStatus: rearCompatibility || frontCompatibility
}))

// TODO change listPrice on actual field
const withViewData = withProps(({
  selectedLocation,
  hasRearTire,
  skuId,
  staggeredSkuId,
  frontTireQuantity,
  rearTireQuantity,
  frontTire: {
    compatibilityStatus: frontCompatibility,
    listPrice: frontPricePerItem,
    tireSize: frontTireSize,
    hasMapPrice: frontHasMapPrice,
    seePriceIncartMessage: frontSeePriceIncartMessage,
    mspn = '',
    bvId: frontTireBvId,
    mapPrice: frontMapPrice
  },
  rearTire: {
    compatibilityStatus: rearCompatibility,
    listPrice: rearPricePerItem,
    tireSize: rearTireSize,
    hasMapPrice: rearHasMapPrice,
    seePriceIncartMessage: rearSeePriceIncartMessage,
    mspn: RearMspn = '',
    bvId: rearTireBvId,
    mapPrice: rearMapPrice
  }
}) => ({
  compatibilityStatus: rearCompatibility || frontCompatibility,
  showSelectLocationLinkInsteadOfPrice: !selectedLocation,
  quantityInputId: `${hasRearTire ? staggeredSkuId : skuId}-id`,
  front: {
    title: hasRearTire ? 'FRONT' : '',
    tireSize: frontTireSize,
    pricePerItem: frontPricePerItem,
    price: getPrice(frontPricePerItem, frontTireQuantity),
    quantity: frontTireQuantity,
    hasMapPrice: frontHasMapPrice,
    seePriceIncartMessage: frontSeePriceIncartMessage,
    mspn,
    frontTireBvId: frontTireBvId || '',
    mapPrice: frontMapPrice || '',
    mapPriceForSet: frontMapPrice ? getPrice(frontMapPrice, frontTireQuantity) : ''
  },
  rear: {
    title: 'REAR',
    tireSize: rearTireSize,
    pricePerItem: rearPricePerItem,
    price: getPrice(rearPricePerItem, rearTireQuantity),
    quantity: rearTireQuantity,
    hasMapPrice: rearHasMapPrice,
    seePriceIncartMessage: rearSeePriceIncartMessage,
    mspn: RearMspn,
    rearTireBvId: rearTireBvId || '',
    mapPrice: rearMapPrice || '',
    mapPriceForSet: rearMapPrice ? getPrice(rearMapPrice, rearTireQuantity) : ''
  }
}))

const withBOTSkuDetailProps = withProps(({
  specifications = []
}) => {
  const electricVehicleSpecifications = getElectricVehicleSpecifications(specifications)

  return {
    evFlag: Boolean(electricVehicleSpecifications.length)
  }
})

export default compose(
  reduxForm({ form: TIRE_QUANTITY_FORM_NAME, enableReinitialize: true }),
  withSelectedLocation,
  withCompatibilityStatus,
  connect(mapStateToProps, { showStoreLocatorModal }),
  withViewData,
  withFormModel,
  withBOTSkuDetailProps
)(TireCost)
